// extracted by mini-css-extract-plugin
export default {"container":"It-z","ratingLayout":"Jt-z","ratingLabel":"Kt-z"};